import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import type { LoginDistribution } from "@/services/api";

const config: ChartConfig = {
  count: { label: "登录次数", color: "#8b5cf6" },
};

export function LoginHoursChart({ data }: { data?: LoginDistribution | null }) {
  const hours = data?.hours ?? [];
  const chartData = hours.map((count, hour) => ({ hour, count }));
  const hasData = data ? data.total > 0 : false;

  // 找出高峰时段
  let peakHour = -1;
  let peakVal = 0;
  hours.forEach((v, h) => {
    if (v > peakVal) {
      peakVal = v;
      peakHour = h;
    }
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>登录时段分布</CardTitle>
        <CardDescription>
          24 小时登录次数分布
          {peakHour >= 0 && ` · 高峰时段 ${peakHour}:00`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {hasData ? (
          <ChartContainer config={config} className="h-[300px] w-full">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="hour"
                tick={{ fontSize: 12 }}
                tickFormatter={(v) => `${v}:00`}
                interval={1}
              />
              <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
              <ChartTooltip
                content={
                  <ChartTooltipContent
                    labelFormatter={(label) => `${label}:00`}
                  />
                }
              />
              <Bar
                dataKey="count"
                fill="var(--color-count)"
                radius={[4, 4, 0, 0]}
                name="登录次数"
              />
            </BarChart>
          </ChartContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground">
            暂无登录数据
          </div>
        )}
      </CardContent>
    </Card>
  );
}
